import moment from 'moment';

// Parses a date filter value back into a LOCAL Date for display in pickers.
// A YYYY-MM-DD string is treated as a local calendar day (avoids the UTC-parsing of
// `new Date('YYYY-MM-DD')`, which shifts the day back for users behind UTC). Legacy
// full ISO instants are still accepted and rendered in local time.
export default function parseDateOnly(value) {
    if (!value) return null;
    const isDateOnly = /^\d{4}-\d{2}-\d{2}$/.test(value);
    const parsed = isDateOnly ? moment(value, 'YYYY-MM-DD') : moment(value);
    return parsed.isValid() ? parsed.toDate() : null;
}
